<template>
  <section class="content">
    <row style="border:0px solid green;">
      <div class="box box-success">
        <div class="box-header with-border">
          <button
            type="button"
            class="btn btn-labeled btn-success"
            style="margin-right: 5px;"
            @click="doOpenCompose()"
            v-if="has_perm('create_send_notification') || GET_ACCOUNT_DATA.id == 1"
          >
            <span class="btn-label"> <i class="fa fa-envelope"></i> </span>
            {{ $t("sidebar.customerfeedbackmanagement.send_email") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success"
            style="margin-right: 5px;"
            @click="doOpenSendSMS()"
            disabled
          >
            <span class="btn-label"> <i class="fa fa-commenting-o"></i> </span>
            {{ $t("sidebar.customerfeedbackmanagement.send_sms") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success"
            style="margin-right: 5px;"
            @click="doOpenSendApp()"
          >
            <span class="btn-label"> <i class="fa fa-mobile"></i> </span>
            {{ $t("sidebar.customerfeedbackmanagement.send_by_app") }}
          </button>
        </div>

        <div class="box-body"></div>
      </div>
    </row>
    <div class="row">
      <div v-if="isShowManagementCompose">
        <ManagementCompose @hideCompose="handleHideCompose" />
      </div>
      <div v-else-if="isShowManagementNotification">
        <send-notification ref="SendNotification"/>
      </div>
      <div v-else>
        <ul class="nav nav-tabs">
          <!-- <li class="active">
            <a data-toggle="tab" href="#mailHistory">Send mail</a>
          </li> -->
          <li class="tab-pane fade in active" v-if="GET_ACCOUNT_DATA.id === 1">
            <a data-toggle="tab" href="#menuSMTP">Mail</a>
          </li>
          <li v-if="GET_ACCOUNT_DATA.id === 1" class="disabled"><a>SMS</a></li>
          <li v-if="GET_ACCOUNT_DATA.id === 1">
            <a data-toggle="tab" href="#menuMobile">Mobile</a>
          </li>
        </ul>

        <div class="tab-content">
          <!-- <div id="mailHistory" class="tab-pane fade in active">
            <mail-history-agent />
          </div> -->
          <div id="menuSMTP" class="tab-pane" v-if="GET_ACCOUNT_DATA.id === 1">
            <menu-mail />
          </div>
          <div
            type="button"
            id="menuSMS"
            class="tab-pane fade"
            v-if="GET_ACCOUNT_DATA.id === 1"
          ></div>
          <div
            id="menuMobile"
            class="tab-pane fade"
            v-if="GET_ACCOUNT_DATA.id === 1"
          >
            <lte-table
              :hdBackground="hdBackground"
              :columns="gridMobileColumns"
              :data="gridMobileDataList"
              :boxStyle="boxStyle"
              :row_mouse_pointer="false"
            ></lte-table>
          </div>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!-- /.row -->
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import MenuMailbox from './MenuMailbox'
import ManagementCompose from "./ManagementCompose";
import LTETable from "@/components/LTETable.vue";
// import i18n from "../../lang";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";
import MenuMail from "./ManagementMenuMail";
import SendNotification from "./SendNotification"

export default {
  name: "ManagementMenu",
  data() {
    return {
      isShowManagementCompose: false,
      isShowManagementNotification: false,

      options: {
        format: "DD-MM-YYYY"
      },
      isLoading: false,
      gridMobileDataList: [],
      gridMobileColumns: [
        { text: "STT", isHidden: true },
        { text: "mail_box.mobile.date_sent", isHidden: true },
        { text: "mail_box.mobile.title", isHidden: true },
        { text: "mail_box.mobile.sub_title", isHidden: true },
        { text: "mail_box.mobile.body", isHidden: true },
        { text: "mail_box.mobile.type", isHidden: true }
      ],
      boxStyle: false,

      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      tabSelect: {
        emailTab: false,
        smsTab: false,
        notiTab: false
      }
    };
  },
  watch: {
    GET_MOBILE_NOTIFICATION_DATA: function() {
      this.gridMobileDataList = [];
      this.GET_MOBILE_NOTIFICATION_DATA.forEach((element, idx) => {
        let message = element.message;
        let data = {
          STT: idx + 1,
          "mail_box.mobile.date_sent": utils.formatDateTime(message.date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm'),
          "mail_box.mobile.title": message.title,
          "mail_box.mobile.sub_title": message.sub_title,
          "mail_box.mobile.body": message.body,
          "mail_box.mobile.type": message.type
        };
        this.gridMobileDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_MOBILE_NOTIFICATION_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_MOBILE_NOTIFICATION",
      "ON_SHOW_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    doOpenCompose() {
      this.isShowManagementNotification = false
      this.isShowManagementCompose = true;
    },
    async handleHideCompose(data) {
      await utils.sleep(1000);
      this.isShowManagementCompose = false;
    },
    doOpenSendSMS() {},
    doOpenSendApp() {
      this.isShowManagementCompose = false
      this.isShowManagementNotification = true
    }
  },
  mounted() {
    this.GET_MOBILE_NOTIFICATION();
  },

  components: {
    // MenuMailbox,
    "lte-table": LTETable,
    ManagementCompose,
    loading: Loading,
    "menu-mail": MenuMail,
    SendNotification
    // "mail-history-agent": MailHistoryAgent
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementMenu.vue